module.exports = __webpack_public_path__ + "static/media/whiteBack2.6de07a81.svg";